import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useAuthToken } from "@convex-dev/auth/react";
import { useUser } from "../hooks/useUser";

interface ProtectedRouteProps {
  children: ReactNode;
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const authToken = useAuthToken();
  const { user, isLoading } = useUser();

  // Wait for both auth token AND user query to load
  // authToken is null when not authenticated, undefined when loading
  const isAuthLoading = authToken === undefined || isLoading;

  if (isAuthLoading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-gray-600">Loading...</div>
      </div>
    );
  }

  if (!user || !authToken) {
    return <Navigate to="/signin" replace />;
  }

  return <>{children}</>;
}
